import React, { useState } from 'react';
import { Bounce, toast } from 'react-toastify';
import StarRating from './StarRating';
import ProModal from '../../../../../common/ProModal';

const Card = ({ addon }) => {
	const [active, setActive] = useState(addon.status === 'active');
	const [showPopup, setShowPopup] = useState(false);
	const [loading, setLoading] = useState(false);

	const showToast = (type, message, onClose = () => {}) => {
		toast[type](
		    <div dangerouslySetInnerHTML={{ __html: message }} />,
		    {
			position: 'top-right',
			style: {
				margin: '30px 0 0 0',
				fontSize: '16px',
				fontWeight: '500',
				lineHeight: '26px',
				color: '#fff',
			},
			autoClose: 1000,
			onClose: onClose,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: false,
			progress: undefined,
			theme: 'colored',
			transition: Bounce,
		});
	};

	const handleAddonAction = async (addon) => {
		if (!addon.slug) return;

		if (!addon.is_free && !addon.accessible && !EASYCOMMERCE.pro.licensed) {
			setShowPopup(true);
			return;
		}

		setLoading(true);

		try {
			const res = await fetch(`${EASYCOMMERCE.rest_base}/addons`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-WP-Nonce': EASYCOMMERCE.nonce,
				},
				body: JSON.stringify({
					action: active ? 'deactivate' : 'activate',
					addon: addon.slug,
				}),
			});

			const data = await res.json();
			setLoading(false);

			if (data.success && data.data.status) {
				showToast('success', data.data.message);
				setActive(!active);
			} else {
				showToast(
					'error',
					data.data.message
				);
			}
		} catch (error) {
			setLoading(false);
			showToast('error', 'Something went wrong. Please try again.');
		}
	};

	return (
		<div className="flex flex-col border border-ec-border rounded-lg hover:shadow-[2px_22px_54.6px_0px_#EFEBFF]">
			<div className="relative">
				<a href={addon.url} target="_blank">
					<img
						className="w-full h-auto rounded-t-lg"
						src={addon.thumbnail}
						alt=""
					/>
				</a>

				{!addon.is_free && <div class="w-5 h-5 rounded-full bg-[#FFC400] flex items-center justify-center absolute top-2 right-2">
					<svg
						class="w-2.5 h-auto"
						width="30"
						height="32"
						viewBox="0 0 30 32"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M28.7358 5.89067C28.2963 5.67649 27.7971 5.61752 27.3198 5.72337C26.8424 5.82922 26.415 6.09365 26.1072 6.47355L21.0442 12.7366L17.044 1.45054C16.8927 1.02606 16.6137 0.658795 16.2454 0.3991C15.8771 0.139405 15.4375 0 14.9868 0C14.5362 0 14.0966 0.139405 13.7282 0.3991C13.3599 0.658795 13.081 1.02606 12.9296 1.45054L8.94095 12.6737L3.86651 6.47926C3.56054 6.09716 3.13443 5.82965 2.65733 5.72013C2.18023 5.6106 1.68011 5.6655 1.23812 5.87591C0.796138 6.08631 0.438209 6.43989 0.222406 6.87927C0.00660331 7.31864 -0.0544117 7.81805 0.0492595 8.29646L3.43221 24.8227H26.5415L29.9244 8.29646C30.0296 7.82005 29.9691 7.32203 29.753 6.88463C29.5369 6.44724 29.1781 6.09662 28.7358 5.89067Z"
							fill="#121216"
						></path>
						<path
							d="M5.98109 27.1025H3.69531V28.4969C3.6947 29.4226 4.0614 30.3108 4.71492 30.9664C5.36844 31.6221 6.2554 31.9917 7.18113 31.9941H22.793C23.7187 31.9917 24.6057 31.6221 25.2592 30.9664C25.9127 30.3108 26.2794 29.4226 26.2788 28.4969V27.1025H5.98109Z"
							fill="#121216"
						></path>
					</svg>
				</div>}
			</div>

			<div className="p-4 h-full flex flex-col justify-between">
				<div>
					<a className="block mb-2" target="_blank" href={addon.url}>
						<h2 className="text-ec-title text-xl leading-[32px] font-medium font-inter">
							{addon.name.slice(0, 30)}
						</h2>
					</a>
					<p className="text-ec-body font-inter text-sm leading-[24px] mb-3 line-clamp-2">
						{addon.desc}
					</p>
				</div>
				<div className="flex items-center justify-between">
					<StarRating rating={addon.rating} />

					{loading ? (
						<img className='h-7' src={`${EASYCOMMERCE.assets}admin/img/loader.gif`} alt="Loading..." />
					) : (
						<button
							className={`p-1 text-[10px] leading-3 text-white 
								font-inter font-normal transition-all duration-300 rounded-full w-[76px] h-7 flex items-center justify-between ${
									active
										? 'bg-ec-primary flex-row-reverse pl-2'
										: 'bg-black/30 pr-2'
								}`}
							onClick={() => {
								handleAddonAction(addon);
							}}
						>
							<div className="h-5 w-5 rounded-full bg-white"></div>

							{active ? 'Enabled' : 'Disabled'}
						</button>
					)}
				</div>
			</div>

			{showPopup && <ProModal setShowPopup={setShowPopup} addonName={addon.name} />}
		</div>
	);
};

export default Card;
